import React from "react";
import { Button, useNotify, useRefresh } from "react-admin";
import FormModal from "server/components/Modals/FormModal";
import EditIcon from "@mui/icons-material/Edit";
import dataProvider from "server/dataProvider";
import MemberFields from "server/components/Fields/MemberFields";
import { specialistRequests } from "api/specialistApi";

const UpdateMemberInfoDialog = ({ id, memberId, excludeIds = [] }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleSubmit = async data => {
    const payload = {
      type: data.type,
      employeeId: data.employeeId,
      externalEmployeeNames: data.externalEmployeeNames,
    };
    await dataProvider.customRequest(specialistRequests.updateExamCommitteeMember(id, memberId), payload, "PUT");
    notify("Успешно заменихте член от изпитната комисия", { type: "success" });
    refresh();
  };

  return (
    <FormModal
      dialogSize="md"
      titleContent={"Замяна на член от комисията"}
      onConfirm={handleSubmit}
      triggerButton={
        <Button
          label="Замени"
          variant="contained"
          startIcon={<EditIcon />}
        />
      }
    >
      <MemberFields excludeIds={excludeIds} />
    </FormModal>
  );
};

export default UpdateMemberInfoDialog;
